export interface ELSummary {
  id: string;
  content: string;
  keyPoints: string[];
  createdAt: string;
  wordCount: number;
}

export interface ELSummaryRequest {
  elId: string;
  elFileName: string;
  includeKeyPoints?: boolean;
  maxLength?: number;
  question?: string;
}

export interface ELChatMessage {
  id: string;
  type: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface ELChatResponse {
  id: string;
  response: string;
  createdAt: string;
}

export interface SummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  elId: string;
  elFileName: string;
}

export enum LoadingState {
  IDLE = 'idle',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}

export enum TabType {
  SUMMARY = 'summary',
  CHAT = 'chat'
}

export const DEFAULT_CHAT_QUESTIONS = [
  "What is the fiscal year covered by this engagement?",
  "What services are included and excluded?",
  "What are the billing terms and payment deadlines?",
  "Who are the parties involved in this agreement?",
  "What are the termination or withdrawal conditions?"
];
